import {AfterViewInit, Component, EventEmitter, Input, OnInit, Output, SimpleChanges} from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { MatCheckbox } from '@angular/material/checkbox';
import { AssignedTeamRoles } from 'app/enums/assigned-team-roles.enum';
import { AssignedTeamMemberType, AssignedTeamMemberTypeId, SuggestType } from 'app/enums/suggest.enum';
import { AssignedTeamItem, Item } from 'app/models/item.inferface';
import { UserModel } from 'app/models/user.model';
import {StakeholdersDto, StakeholdersIdsDto} from 'app/models/workflow/workflow-instance.interface';
import { AuthService } from 'app/services/auth.service';
import { ConsultantByDescriptionSuggestService } from 'app/services/suggest/consultant-by-description.suggest.service';
import { ToastService } from 'app/services/toast.service';
import { Observable, Subscription } from 'rxjs';
import { tap } from 'rxjs/operators';

@Component({
  selector: 'app-role-users',
  templateUrl: './role-users.component.html',
  styleUrls: ['./role-users.component.scss']
})
export class RoleUsersComponent implements OnInit, AfterViewInit {

  suggestType = SuggestType;
  memberType = AssignedTeamMemberType;
  memberTypeId = AssignedTeamMemberTypeId;
  assignedTeamRoles = AssignedTeamRoles;

  @Input()
  public editable: boolean;

  @Input()
  public detailMode: boolean;

  @Input()
  public onlyUsers: boolean;
  
  @Input()
  stakeholdersConfig: StakeholdersIdsDto = null;

  @Input() onContinueObservable: Observable<void>;
  private onContinueSuscription: Subscription;

  @Output()
  assignedResponders: EventEmitter<StakeholdersIdsDto> = new EventEmitter();

  form: FormGroup;

  loadingUsers = false;
  loadingGroups = false;

  checking = false;

  teamSelected: AssignedTeamItem[] = []; 
  selectedListUser: number[] = [];
  selectedListGroup: number[] = [];

  public userIds: Item[] = [];
  public userGroupIds: Item[] = [];

  currentUser: UserModel;
  canAddTeam: boolean = false;

  constructor(
    private suggestService: ConsultantByDescriptionSuggestService,
    private authService: AuthService,
    private toast: ToastService
  ) {
    this.currentUser = this.authService.currentUser;
  }

  ngOnInit(): void {

    this.form = new FormGroup({
      user: new FormControl()
    });

    if(this.stakeholdersConfig) this.setInitialStakeholders();
    
    this.form.get('user').valueChanges
      .subscribe(value => {
        if (value && typeof value == 'object') {
          this.canAddTeam = true;
         
        }else{
          this.canAddTeam = false;
        }
      })
  }

  ngAfterViewInit() {
    this.form.disable({emitEvent: false});
    if (!this.editable) {
      this.form.enable({emitEvent: true});
    }
    
    this.onContinueSuscription = this.onContinueObservable?.subscribe(() => {
      setTimeout(() => {
        if(this.stakeholdersConfig) this.setInitialStakeholders();
      },500);
    });
  }

  ngOnDestroy(): void {
    this.onContinueSuscription?.unsubscribe();
  }

  setInitialStakeholders(): void {
    this.teamSelected = [];
    this.userIds = [];
    this.userGroupIds = [];
    
    let userIds: number[] = [];
    let groupIds: number[] = [];
    console.log(this.stakeholdersConfig)
    for (const prop in this.stakeholdersConfig) {
      if (prop.includes('userGroupIds')) {
        groupIds = [...this.stakeholdersConfig[prop]];
      } else if (prop.includes('userIds')) {
        userIds = [...this.stakeholdersConfig[prop]];
      }else if(prop.includes('reviewers')){
        userIds = this.stakeholdersConfig[prop].map(x => {return x.userId});
      }
    }
   
    userIds = [...new Set(userIds)];
    groupIds = [...new Set(groupIds)];
      
    this.suggestService.getTeamById(userIds, this.memberTypeId.User).subscribe(response => {
      this.setInitialUsers(response);
    });
  
    if (!this.onlyUsers) {
      this.suggestService.getTeamById(groupIds, this.memberTypeId.Group).subscribe(response => {
        this.setInitialGroups(response);
      });
    }
  }
  
  setInitialUsers(users: AssignedTeamItem[]): void {
    this.teamSelected = this.teamSelected.concat(users.filter(user => 
      !this.userIds.some(existingUser => existingUser.id === user.id)
    ));
  
    this.userIds.push(...users.map(user => ({ id: user.id, description: user.description })));
  }
  
  setInitialGroups(groups: AssignedTeamItem[]): void {
    this.teamSelected = this.teamSelected.concat(groups.filter(group => 
      !this.userGroupIds.some(existingGroup => existingGroup.id === group.id)
    ));
  
    this.userGroupIds.push(...groups.map(group => ({ id: group.id, description: group.description })));
  }
 
  addMembers(): void {
    if(this.form.get('user').value){
      this.form.get('user').value.forEach(user => {
        if (!this.teamSelected.find(x => x.id == user.id && x.type == user.type)) {
          this.teamSelected.push(user);
          this.updateStakeholderRole(user);
        }
      });
    }
    this.form.get('user').setValue(null);
    this.canAddTeam = false;
  }

  updateStakeholderRole(item: AssignedTeamItem, $event?: any): void {

    $event?.stopPropagation();

   

    switch(item.type) {
      case AssignedTeamMemberType.User:
        this.userIds = this.removeItem(item, this.userIds);
        this.userIds.push({id: item.id, description: item.description})
        break;
      case AssignedTeamMemberType.Group:
        this.userGroupIds = this.removeItem(item, this.userGroupIds);
        this.userGroupIds.push({id: item.id, description: item.description})
        break;
    }

    this.stakeholdersUpdated();
  } 

  removeItem (item: AssignedTeamItem, array: Item[]): Item[] {
    return array.filter(value => item.id != value.id);
  }

  stakeholdersUpdated(): void {
    const newStakeholders: StakeholdersIdsDto = {
      userIds:  [...this.userIds.map(user => user.id)],
      userGroupIds: [...this.userGroupIds.map(userGroup => userGroup.id)],
    }
    this.assignedResponders.emit(newStakeholders);
  }

  itemCheck(item, e) {  
    this.checking = true;  
    if (e.checked) {
      switch(item.type) {
        case AssignedTeamMemberType.User:
          this.selectedListUser.push(item.id);
          break;
        case AssignedTeamMemberType.Group:
          this.selectedListGroup.push(item.id);
          break;
      }        
    } else {
      switch(item.type) {
        case AssignedTeamMemberType.User:
          if (this.selectedListUser.includes(item.id)) {
            const i = this.selectedListUser.indexOf(item.id);
            this.selectedListUser.splice(i, 1);
          }
          break;
        case AssignedTeamMemberType.Group:
          if (this.selectedListGroup.includes(item.id)) {
            const i = this.selectedListGroup.indexOf(item.id);
            this.selectedListGroup.splice(i, 1);
          }
          break;
      }    
        
    }
    this.checking = false; 
  }

  toggleCheckbox(member: any, checkbox: MatCheckbox) {
    if (!this.checking) { 
        member.selected = !member.selected; 
        this.itemCheck(member, { checked: member.selected }); 
    }
  }

  deleteMembers(): void {
  if (this.teamSelected.length > 0) { 
    if (this.selectedListUser.length > 0) {     
      this.selectedListUser.forEach(element => {
        const index = this.teamSelected.findIndex(x => x.id === element && x.type === AssignedTeamMemberType.User);
        if (index !== -1) this.teamSelected.splice(index, 1);
      });   
      this.userIds = this.userIds.filter(user => !this.selectedListUser.includes(user.id));
      this.form.get('user').setValue(null);
      this.selectedListUser = [];
      this.stakeholdersUpdated();  
    }  

    if (this.selectedListGroup.length > 0) {     
      this.selectedListGroup.forEach(element => {
        const index = this.teamSelected.findIndex(x => x.id === element && x.type === AssignedTeamMemberType.Group);
        if (index !== -1) this.teamSelected.splice(index, 1);
      });   
      this.userGroupIds = this.userGroupIds.filter(group => !this.selectedListGroup.includes(group.id)); 
      this.form.get('user').setValue(null);
      this.selectedListGroup = [];
      this.stakeholdersUpdated();  
    } 
  }    
}

ngOnChanges(changes: SimpleChanges): void {
  if (changes['stakeholdersConfig']) {
    if (this.stakeholdersConfig) {
      this.setInitialStakeholders();
    } else {      
      this.clearStakeholders();
    }
  }
}

clearStakeholders(): void {
  this.userIds = [];
  this.userGroupIds = [];
  this.teamSelected = [];
  this.stakeholdersUpdated();
}
}
